import { render, staticRenderFns } from "./VlExaminationDocuments.vue?vue&type=template&id=e266dc56&scoped=true&"
import script from "./VlExaminationDocuments.vue?vue&type=script&lang=js&"
export * from "./VlExaminationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e266dc56",
  null
  
)

export default component.exports